import { gql } from "@apollo/client";

export const GET_ALL_CLASIFICACIONES_MONITOREO = gql`
query GetAllResultadoClasificiacionMonitoreo {
    allClaseMonitoreo
    {
        idClaseMonitoreo
        descripcion
    }
}`;

export const adaptClasificacionMonitoreo = (clasificacionMonitoreo) => {
  return {
    id: clasificacionMonitoreo?.idClaseMonitoreo,
    displayName: clasificacionMonitoreo?.descripcion

  };
};

const adaptClasificacionesMonitoreoArray = (clasificacionesMonitoreo) => {

  return structuredClone(clasificacionesMonitoreo?.allClaseMonitoreo)?.
  map((clasificacionMonitoreo) => adaptClasificacionMonitoreo(clasificacionMonitoreo)) || [];
};

export default adaptClasificacionesMonitoreoArray;